import { withTranslation } from "react-i18next";
import ThreeHorseLoading from "react-loadingg/lib/ThreeHorseLoading";
import './LoadingList.css'

const commonStyle = {
    margin: 'auto',
    position: 'initial',
    left: 0,
    right: 0,
    top:10,
    bottom:10
};

function LoadingList({t,texto}) {
    setTimeout(()=>{
        if (document.getElementById('idSeccionConferencia')){
            document.getElementById('idSeccionConferencia').setAttribute('hidden', 'hidden');
        }
    }, 100)
    return  (
        <div className="react-loader-overlay">
            <div className="react-confirm-alert">
                <div className="custom-ui">
                        <h2>{texto ? texto : `${t('cargando')}...`}</h2>
                        <ThreeHorseLoading color={"#6586FF"} style={commonStyle}/>
                </div>
            </div>
        </div>
    )
}

export default withTranslation()(LoadingList)